export default function getResource(label, vars = []) {
    const resources = {
        deliveringTo: 'Livrer à ',
        yourLocation: 'votre emplacement',
        notAvailable: 'La livraison le jour même n’est pas disponible pour ',
        fastDeliveryNotAvailable: 'La livraison rapide n’est pas disponible pour ',
        changeLocation: 'Changer d’emplacement'
    };
    return resources[label];
}
